import { FunnelStepId } from 'modules/funnels/funnel/types/funnel-step-interface'
import { FunnelId } from 'modules/funnels/types/funnel-interface'

export const getFunnelStepUrl = (funnelId: FunnelId, funnelStep: FunnelStepId) =>
  `/funnels/${funnelId}?step=${funnelStep}`
